{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/PAINAD",
	"name": "PAINAD",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Échelle de PAINAD",
	"purpose": "Évalue la douleur en cas de démence avancée",
	"description": "Chaque item est scoré sur une échelle de 0 à 2. Lorsque les 5 scores sont additionnés, le score total varie de 0 —pas de douleur— à 10—douleur majeure.",
	"item": [
		{
			"linkId": "185",
			"text": "Respiration",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "460",
						"display": "Normale"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					]
				},
				{
					"valueCoding": {
						"code": "461",
						"display": "Occasionnellement laborieuse - Courtes périodes d’hyperventilation"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "462",
						"display": "Bruyante, pénible - Longues périodes d’hyperventilation - Cheyne-Stokes"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				}
			]
		},
		{
			"linkId": "187",
			"text": "Vocalisation négative",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "463",
						"display": "Aucune"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					]
				},
				{
					"valueCoding": {
						"code": "464",
						"display": "Gémissements occasionnels - Discours peu élaboré à voix basse"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "465",
						"display": "Appels inquiets répétés - Forts gémissements - Pleurs"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				}
			]
		},
		{
			"linkId": "189",
			"text": "Expression faciale",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "466",
						"display": "Souriant ou inexpressif"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					]
				},
				{
					"valueCoding": {
						"code": "467",
						"display": "Triste, effrayé, froncement du visage"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "468",
						"display": "Grimaces"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				}
			]
		},
		{
			"linkId": "191",
			"text": "Langage corporel",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "469",
						"display": "Détendu"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					]
				},
				{
					"valueCoding": {
						"code": "470",
						"display": "Tendu - Va et vient avec inquiétude - Agité"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "471",
						"display": "Rigide, poings serrés - Se retire ou repousse"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				}
			]
		},
		{
			"linkId": "193",
			"text": "Consolation",
			"type": "choice",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl",
					"valueCodeableConcept": {
						"coding": [
							{
								"system": "http://hl7.org/fhir/questionnaire-item-control",
								"code": "radio-button",
								"display": "Radio Button"
							}
						]
					}
				}
			],
			"required": true,
			"answerOption": [
				{
					"valueCoding": {
						"code": "472",
						"display": "Pas besoin d’être consolé"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 0
						}
					]
				},
				{
					"valueCoding": {
						"code": "473",
						"display": "Distrait ou rassuré par la voix ou le toucher"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 1
						}
					]
				},
				{
					"valueCoding": {
						"code": "474",
						"display": "Impossible à consoler, distraire ou rassurer"
					},
					"extension": [
						{
							"url": "http://hl7.org/fhir/StructureDefinition/itemWeight",
							"valueDecimal": 2
						}
					]
				}
			]
		}
	]
}
